var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default',[_c('div',{staticClass:"tw-w-full"},[_c('vue-json-to-csv',{attrs:{"json-data":_vm.statement,"labels":{
      mtranDate: { title: 'Transaction Date'},
      debitCredit: { title: 'Debit/Credit'},
      narration: { title: 'Narration'},
      totalAmount: { title: 'Total Amount'},
      insured: { title: 'Insured'},
      polPolicyCoverFrom: { title: 'Cover From'},
      polPolicyCoverTo: { title: 'Cover To'},
      proDesc: { title: 'Product'},
      polPolicyNumber: { title: 'Policy Number'},
      },"csv-title":'Statement'}},[_c('v-btn',{staticClass:"mr-6",attrs:{"color":"success"}},[_vm._v(" Export "),_c('i',{staticClass:"mdi mdi-export-variant",attrs:{"aria-hidden":"true"}})])],1),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.statement,"item-key":"name"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }